import { lazy } from "react";

const categoryRoutes = [
        // Chat (disabled - gRPC/proto dependency removed)
        // { path: '/chat/chat', component: lazy(() => import('../../views/chat')) },
];

export default categoryRoutes